export default __webpack_public_path__ + "static/media/5t.258178a6.jpg";